
const isTouch = matchMedia('(hover:none)').matches;
const isSmall = innerWidth < 860;

/* ================= PARTICLE WAVE (guarded: a CDN failure can never kill the page) ================= */
(function(){
try{
if (typeof THREE === 'undefined') return;
const canvas = document.getElementById('axis-canvas');
if (!canvas) return;
const renderer = new THREE.WebGLRenderer({canvas, antialias:!isSmall, alpha:true});
renderer.setPixelRatio(Math.min(window.devicePixelRatio, isSmall?1.5:2));
renderer.setSize(innerWidth, innerHeight);
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(50, innerWidth/innerHeight, .1, 100);
camera.position.set(0, 1.4, isSmall?12:10);

const COUNT = isSmall ? 3000 : 8000;
const cols = isSmall?80:120;
const pos=new Float32Array(COUNT*3);
const geo=new THREE.BufferGeometry();
geo.setAttribute('position',new THREE.BufferAttribute(pos,3));
const vcols=new Float32Array(COUNT*3);
const cA=new THREE.Color(0x8d9bff), cB=new THREE.Color(0xf1d39a), cC=new THREE.Color(0xe9e8e1);
for(let i=0;i<COUNT;i++){
  const r=i%9; const c=r<2?cA:(r<3?cB:cC);
  vcols[i*3]=c.r;vcols[i*3+1]=c.g;vcols[i*3+2]=c.b;
}
geo.setAttribute('color',new THREE.BufferAttribute(vcols,3));
const mat=new THREE.PointsMaterial({vertexColors:true,size:isSmall?.045:.03,transparent:true,opacity:.9,depthWrite:false,blending:THREE.AdditiveBlending});
scene.add(new THREE.Points(geo,mat));

let tmx=0,tmy=0,mx=0,my=0,smooth=0;
const mouse3=new THREE.Vector3();
if(!isTouch){addEventListener('mousemove',e=>{tmx=(e.clientX/innerWidth-.5)*2;tmy=-(e.clientY/innerHeight-.5)*2},{passive:true})}
addEventListener('resize',()=>{camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();renderer.setSize(innerWidth,innerHeight)});
const clock=new THREE.Clock();
const nightStart=document.getElementById('night-start');
const nsSafe=()=>nightStart?nightStart.offsetTop:Number.MAX_SAFE_INTEGER;

function tick(){
  const t=clock.getElapsedTime();
  smooth+=(window.scrollY-smooth)*.06;
  const nsTop=nsSafe();
  const full=document.documentElement.scrollHeight-innerHeight;
  const pN=Math.min(Math.max((smooth-nsTop+innerHeight*.6)/Math.max(full-nsTop,1),0),1);
  mx+=(tmx-mx)*.05;my+=(tmy-my)*.05;

  let mwx=0,mwy=0;
  if(!isTouch){
    mouse3.set(mx,my,.5).unproject(camera);
    mouse3.sub(camera.position).normalize();
    const dist=-camera.position.z/mouse3.z;
    mwx=camera.position.x+mouse3.x*dist;
    mwy=camera.position.y+mouse3.y*dist;
  }
  const ph=t*.9+pN*4;
  for(let i=0;i<COUNT;i++){
    const i3=i*3, xx=(i%cols)/cols, zz=Math.floor(i/cols)/(COUNT/cols);
    let x=(xx-.5)*15;
    let z=(zz-.5)*11;
    let y=Math.sin(xx*8+ph)*Math.cos(zz*6+ph*.7)*(1.0+pN*.5)-1.6;
    if(!isTouch){
      const dx=x-mwx,dy=y-mwy,d2=dx*dx+dy*dy;
      if(d2<2.4){const f2=(2.4-d2)/2.4*.5;x+=dx*f2;y+=dy*f2}
    }
    pos[i3]=x;pos[i3+1]=y;pos[i3+2]=z;
  }
  geo.attributes.position.needsUpdate=true;
  camera.position.x=mx*.7;
  camera.position.y=1.4+my*.5-pN*.8;
  camera.lookAt(0,-.4,0);
  renderer.render(scene,camera);
  requestAnimationFrame(tick);
}
tick();
}catch(e){console.warn('axis: particle wave skipped', e);}
})();

/* ================= SPOTLIGHT + MAGNETIC CTAS ================= */
if(!isTouch){
  const spot=document.getElementById('spotlight');
  addEventListener('mousemove',e=>{
    spot.style.setProperty('--sx',e.clientX+'px');
    spot.style.setProperty('--sy',e.clientY+'px');
  },{passive:true});
  document.querySelectorAll('.mag').forEach(b=>{
    b.addEventListener('mousemove',e=>{
      const r=b.getBoundingClientRect();
      const dx=(e.clientX-(r.left+r.width/2))/r.width;
      const dy=(e.clientY-(r.top+r.height/2))/r.height;
      b.style.transform=`translate(${dx*8}px,${dy*6}px) scale(1.05)`;
    });
    b.addEventListener('mouseleave',()=>{b.style.transform=''});
  });
}

/* ================= NIGHT TOGGLE ================= */
const nightStartEl=document.getElementById('night-start');
function nightCheck(){
  if(!nightStartEl){document.body.classList.remove('night');return}
  const r=nightStartEl.getBoundingClientRect();
  document.body.classList.toggle('night', r.top < innerHeight*.55);
}
addEventListener('scroll',nightCheck,{passive:true});
nightCheck();

/* ================= CURSOR ================= */
if(!isTouch){
  const cur=document.getElementById('cursor');
  let cx=innerWidth/2,cy=innerHeight/2,px=cx,py=cy,seen=false;
  addEventListener('mousemove',e=>{cx=e.clientX;cy=e.clientY;if(!seen){seen=true;document.body.classList.add('cursor-on')}},{passive:true});
  (function cloop(){px+=(cx-px)*.2;py+=(cy-py)*.2;cur.style.transform=`translate(${px}px,${py}px) translate(-50%,-50%)`;requestAnimationFrame(cloop)})();
  document.querySelectorAll('a,button,summary,.card,.tier,.svc,.stat,.proc').forEach(el=>{
    el.addEventListener('mouseenter',()=>cur.classList.add('big'));
    el.addEventListener('mouseleave',()=>cur.classList.remove('big'));
  });
}

/* ================= LOADER: enver-style (no dependencies, cannot trap) ================= */
(function(){
  const loader=document.getElementById('loader');
  if(!loader) return;
  loader.style.animation='none'; /* JS alive: take over from the CSS failsafe */
  const countEl=loader.querySelector('.lx-load-count');
  const barEl=loader.querySelector('.lx-load-bar i');
  requestAnimationFrame(()=>loader.classList.add('go'));
  const t0=performance.now(), dur=1500;
  function ease(k){return 1-Math.pow(1-k,3)}
  (function step(now){
    const k=Math.min((now-t0)/dur,1), v=Math.round(ease(k)*100);
    if(countEl)countEl.textContent=v;
    if(barEl)barEl.style.width=v+'%';
    if(k<1){requestAnimationFrame(step);return}
    loader.classList.add('exit');
    setTimeout(()=>{
      loader.classList.add('done');
      document.body.classList.add('loaded');
      document.dispatchEvent(new CustomEvent('axis:loaded'));
      setTimeout(()=>loader.remove(),1100);
    },380);
  })(t0);
})();

/* ================= SMOOTH SCROLL + VELOCITY SKEW (guarded enhancement) ================= */
(function(){
try{
  if (typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
  if (typeof Lenis !== 'undefined' && !isTouch){
    const lenis=new Lenis({lerp:.1,smoothWheel:true});
    if (typeof ScrollTrigger !== 'undefined') lenis.on('scroll',ScrollTrigger.update);
    gsap.ticker.add(t=>lenis.raf(t*1000));
    gsap.ticker.lagSmoothing(0);
  }
  const mtrack=document.querySelector('.lx-marq-track');
  if (mtrack && typeof ScrollTrigger !== 'undefined'){
    const setSkew=gsap.quickSetter(mtrack,'skewX','deg');
    const clampV=gsap.utils.clamp(-6,6);
    let cur=0;
    ScrollTrigger.create({onUpdate:self=>{
      const s=clampV(self.getVelocity()/-240);
      if(Math.abs(s)>Math.abs(cur)){cur=s;
        gsap.to({v:cur},{v:0,duration:.7,ease:'power3',overwrite:true,onUpdate:function(){cur=this.targets()[0].v;setSkew(cur);}});
      }
    }});
  }
}catch(e){console.warn('axis: motion enhancement skipped', e);}
})();

/* ================= CLIENT PREVIEWS: provider chain + retry ================= */
/* thum.io → wordpress mshots → styled fallback. Sequential load to dodge rate limits. */
const previewImgs=[...document.querySelectorAll('.card .thumb img[data-site]')];
function providerUrls(site){
  return [
    'https://image.thum.io/get/width/1200/crop/2200/noanimate/'+site,
    'https://s0.wp.com/mshots/v1/'+encodeURIComponent(site)+'?w=1200&h=1800'
  ];
}
function loadPreview(img, attempt=0){
  const urls=providerUrls(img.dataset.site);
  if(attempt>=urls.length*2) return;            /* both providers, 2 passes */
  const url=urls[attempt%urls.length] + (attempt>=urls.length ? ((urls[attempt%urls.length].includes('?')?'&':'?')+'r='+Date.now()) : '');
  const probe=new Image();
  probe.onload=()=>{
    /* mshots returns a tiny "generating" gif first; treat small images as not-ready */
    if(probe.naturalWidth<400){ setTimeout(()=>loadPreview(img, attempt+1), 2500); return; }
    img.src=url; img.classList.add('ok');
  };
  probe.onerror=()=>setTimeout(()=>loadPreview(img, attempt+1), 1200);
  probe.src=url;
}
/* stagger: one every 700ms so we never burst the free tier */
previewImgs.forEach((img,i)=>setTimeout(()=>loadPreview(img), i*700));

/* ================= REVEALS + COUNTERS ================= */
const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const cio=new IntersectionObserver(es=>{
  es.forEach(e=>{
    if(!e.isIntersecting)return;
    const el=e.target,end=+el.dataset.count,suf=el.dataset.suffix||'';
    if(isNaN(end)){cio.unobserve(el);return}
    const t0=performance.now(),dur=1400;
    (function step(now){const k=Math.min((now-t0)/dur,1);el.textContent=Math.round(end*(1-Math.pow(1-k,3)))+suf;if(k<1)requestAnimationFrame(step)})(t0);
    cio.unobserve(el);
  });
},{threshold:.5});
document.querySelectorAll('.num[data-count]').forEach(el=>cio.observe(el));

/* ================= MOBILE STICKY CTA ================= */
const sticky=document.getElementById('stickyCta');
if(sticky){
  addEventListener('scroll',()=>{
    const p=window.scrollY/Math.max(document.documentElement.scrollHeight-innerHeight,1);
    sticky.classList.toggle('show', p>.25 && p<.92);
  },{passive:true});
}
